import React from 'react';
import { CheckIcon, FileDownIcon, GlobeIcon, PrinterIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from '../ui/CtaButton';
import { Eyebrow } from '../ui/Eyebrow';
import { heroMockupUrl, included, offer } from '../../data/offer';
import { getCheckoutHref, getPriceNumber } from '../../utils/offer';
export function PrimaryOffer() {
  const price = getPriceNumber();
  return <section id="offer-details" aria-labelledby="offer-heading" className="scroll-mt-4 bg-mint" data-id="element-176" data-mp="1c29jdl21rf3r">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:px-5 md:py-24" data-id="element-177" data-mp="1h01cujicb9a2">
        <div className="mx-auto max-w-3xl text-center" data-id="element-178" data-mp="1lr9kba040kkl">
          <Eyebrow onLight data-id="element-179" data-mp="1lskq1fd482ec">Your complete package</Eyebrow>
          <h2 id="offer-heading" className="mt-3 font-display text-5xl font-extrabold uppercase leading-[0.92] text-forest md:text-6xl" data-id="element-180" data-mp="1psmntdfqcboc">
            Get your next 6 months <span className="text-gold-dark" data-id="element-181" data-mp="1zqsqhx9d1lu9">planned today</span>
          </h2>
        </div>

        <div className="mx-auto mt-10 max-w-[36rem] bg-white px-5 py-8 shadow-[0_20px_50px_-20px_rgba(9,40,29,0.3)] sm:px-10 sm:py-10" data-id="element-182" data-mp="3a19q4ci5bt46">
          <div className="text-center" data-id="element-183" data-mp="351598ldbswdf">
            <h3 className="font-display text-4xl font-extrabold uppercase leading-none text-forest" data-id="element-184" data-mp="354ayc0lyfy95">
              HYROX Mega Pack™ — <span className="text-gold-dark" data-id="element-185" data-mp="2w1rzdrlai5s6">Complete Package</span>
            </h3>
            <p className="mt-2 text-base font-medium text-forest/70" data-id="element-186" data-mp="2w3uwsworv16x">26-Week Training Plan + 5 Strategic Bonuses</p>
          </div>

          <img src={heroMockupUrl} alt="HYROX Mega Pack plan and five bonuses" loading="lazy" width={1254} height={1254} className="mx-auto mt-6 h-auto w-full max-w-sm rounded-lg bg-onyx" data-id="element-187" data-mp="3opxkwgk63yt2" />

          <div className="mt-8 border-t border-forest/10 pt-7" data-id="element-188" data-mp="gadx3x29n8le">
            <p className="text-center text-xs font-bold uppercase tracking-[0.18em] text-forest" data-id="element-189" data-mp="gbozptjz6aax">What's included</p>
            <ul className="mt-5 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-190" data-mp="bhkubeqcyaby">
              {included.map(item => <li key={item} className="flex items-start gap-2.5 text-base font-medium text-forest" data-id="element-191" data-mp="zezi0txgvc07">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold-cream" data-id="element-192" data-mp="lnkmjnmdhic9">
                    <CheckIcon aria-hidden="true" className="h-3 w-3 text-gold-dark" strokeWidth={3} data-id="element-193" data-mp="poeaui3q8z5o" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>

          {price && <div className="mt-7 border-t border-forest/10 pt-7 text-center" data-id="element-194" data-mp="gpsy53kxsect">
              <p className="flex items-start justify-center font-display font-extrabold leading-none text-forest" data-id="element-195" data-mp="2q1lb665p40e">
                <span className="mt-4 text-4xl" data-id="element-196" data-mp="6qlkefaaihp6">$</span>
                <span className="text-[6.5rem]" data-id="element-197" data-mp="1x27vq2r87grn">{price}</span>
                <span className="ml-1 self-end pb-3 font-sans text-base font-semibold text-forest/70" data-id="element-198" data-mp="1x0wvue0wit5t">
                  {offer.currency}
                </span>
              </p>
              <p className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs font-bold uppercase tracking-[0.14em] text-forest/80" data-id="element-199" data-mp="3lmn8iu3663fz">
                <span className="bg-gold-dark px-3 py-1.5 text-white" data-id="element-200" data-mp="3vcq7rc0vwdmr">Digital PDF</span>
                <span data-id="element-201" data-mp="3qlqdkej5g9ny">Pay in local currency</span>
              </p>
            </div>}

          <div className="mt-7" data-id="element-202" data-mp="94qfdnafnhc2">
            <CtaButton href={getCheckoutHref()} fullWidth data-id="element-203" data-mp="93xc4waon9yo">
              Get HYROX Mega Pack now
            </CtaButton>
          </div>
          {offer.guaranteeDays && <p className="mt-4 flex items-center justify-center gap-1.5 text-sm font-medium text-forest/80" data-id="element-204" data-mp="i66ntphot9dn">
              <ShieldCheckIcon aria-hidden="true" className="h-4 w-4 text-gold-dark" data-id="element-205" data-mp="d6bzntpaqxwa" />
              Backed by our {offer.guaranteeDays}-day guarantee
            </p>}

          <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 border-t border-forest/10 pt-5 text-sm font-medium text-forest/75" data-id="element-206" data-mp="2ey6w522zevtx">
            <li className="flex items-center gap-1.5" data-id="element-207" data-mp="2hc29paw5awmq">
              <FileDownIcon aria-hidden="true" className="h-4 w-4" data-id="element-208" data-mp="2ldxamea5z7zz" />
              Downloadable PDF
            </li>
            <li className="flex items-center gap-1.5" data-id="element-209" data-mp="2qd0hm49pfoal">
              <PrinterIcon aria-hidden="true" className="h-4 w-4" data-id="element-210" data-mp="2qbgym5wnyz54" />
              Print-ready
            </li>
            <li className="flex items-center gap-1.5" data-id="element-211" data-mp="1xomhniz22hwe">
              <GlobeIcon aria-hidden="true" className="h-4 w-4" data-id="element-212" data-mp="1xpxmzn85fxpm" />
              Local currency
            </li>
          </ul>
        </div>
        <p className="mx-auto mt-5 max-w-[36rem] text-center text-sm text-forest/70" data-id="element-213" data-mp="22lcyw9mljjje">
          Price shown in USD — you'll be charged the equivalent in your local currency, so there's nothing to worry
          about.
        </p>
      </div>
    </section>;
}